import { Avatar } from "@chakra-ui/react";

interface PropTypes extends Avatar.RootProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "2xs";
  profileImageSrc?: string;
  displayName?: string;
}

const AvatarImage = ({
  size = "xs",
  profileImageSrc,
  displayName,
  ...rest
}: PropTypes) => {
  return (
    <Avatar.Root data-bark-component="AvatarImage" cursor="pointer" size={size} {...rest}>
      <Avatar.Fallback name={displayName} />
      <Avatar.Image src={profileImageSrc} />
    </Avatar.Root>
  );
};

export default AvatarImage;
